/* Low Scoring — theme behaviour. Vanilla, no dependencies. */
(function () {
  'use strict';

  /* ---- Mobile nav toggle ---- */
  document.addEventListener('click', function (e) {
    var toggle = e.target.closest('[data-nav-toggle]');
    if (toggle) {
      var nav = document.querySelector('[data-site-nav]');
      if (nav) {
        var open = nav.classList.toggle('is-open');
        toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      }
    }
  });

  /* ---- Ajax add-to-cart + bag count ---- */
  function updateBagCount(count) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
      el.hidden = false;
    });
  }

  async function refreshCartCount() {
    try {
      var res = await fetch(window.routes.cart_url + '.js', { headers: { Accept: 'application/json' } });
      var cart = await res.json();
      updateBagCount(cart.item_count);
    } catch (err) { /* noop */ }
  }

  /* ---- Add-to-cart toast ---- */
  function showToast(item) {
    var stack = document.querySelector('[data-toast-stack]');
    if (!stack) {
      stack = document.createElement('div');
      stack.className = 'toast-stack';
      stack.setAttribute('data-toast-stack', '');
      document.body.appendChild(stack);
    }
    var toast = document.createElement('div');
    toast.className = 'toast';
    toast.setAttribute('role', 'status');
    toast.innerHTML =
      '<div class="toast__body">' +
        '<span class="toast__eyebrow u-mono">Added to bag ✓</span>' +
        '<p class="toast__title u-display"></p>' +
        '<a class="toast__link u-mono">View bag →</a>' +
      '</div>' +
      '<button class="toast__close" type="button" aria-label="Dismiss">&times;</button>';
    toast.querySelector('.toast__title').textContent = (item && (item.product_title || item.title)) || 'Item';
    toast.querySelector('.toast__link').href = window.routes.cart_url;

    var imgUrl = item && (item.image || (item.featured_image && item.featured_image.url));
    if (imgUrl) {
      var img = document.createElement('img');
      img.className = 'toast__img';
      img.alt = '';
      img.src = imgUrl + (imgUrl.indexOf('?') > -1 ? '&' : '?') + 'width=120';
      toast.insertBefore(img, toast.firstChild);
    }

    stack.appendChild(toast);
    requestAnimationFrame(function () { toast.classList.add('is-visible'); });

    var timer = setTimeout(remove, 4000);
    function remove() {
      clearTimeout(timer);
      toast.classList.remove('is-visible');
      setTimeout(function () { toast.remove(); }, 220);
    }
    toast.querySelector('.toast__close').addEventListener('click', remove);
  }

  document.addEventListener('submit', async function (e) {
    var form = e.target.closest('form[action$="/cart/add"], product-form form');
    if (!form || !form.matches('[data-product-form]')) return;
    e.preventDefault();
    var btn = form.querySelector('[type="submit"]');
    var original = btn ? btn.textContent : '';
    if (btn) { btn.setAttribute('aria-disabled', 'true'); btn.textContent = 'Adding…'; }
    try {
      var res = await fetch(window.routes.cart_add_url, {
        method: 'POST',
        headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: new FormData(form)
      });
      if (!res.ok) throw new Error('add failed');
      var item = await res.json();
      await refreshCartCount();
      showToast(item);
      if (form.closest('[data-quick-drawer]')) closeQuickDrawer();
      if (btn) btn.textContent = 'Added ✓';
      setTimeout(function () { if (btn) { btn.textContent = original; btn.removeAttribute('aria-disabled'); } }, 1400);
    } catch (err) {
      if (btn) { btn.textContent = original; btn.removeAttribute('aria-disabled'); }
      form.submit();
    }
  });

  /* ---- Cart line quantity changes (cart page) ---- */
  document.addEventListener('change', async function (e) {
    var input = e.target.closest('[data-cart-qty]');
    if (!input) return;
    var line = input.getAttribute('data-line');
    try {
      var res = await fetch(window.routes.cart_change_url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ line: parseInt(line, 10), quantity: parseInt(input.value, 10) })
      });
      if (res.ok) window.location.reload();
    } catch (err) { window.location.reload(); }
  });

  /* ---- Collection view toggle (grid / list) ---- */
  (function () {
    var results = document.querySelector('[data-collection-results]');
    if (!results) return;
    var gridEl = results.querySelector('[data-view-grid]');
    var listEl = results.querySelector('[data-view-list]');
    var btns = document.querySelectorAll('[data-view-btn]');
    function apply(view) {
      if (gridEl) gridEl.hidden = view === 'list';
      if (listEl) listEl.hidden = view !== 'list';
      btns.forEach(function (b) { b.classList.toggle('is-active', b.getAttribute('data-view-btn') === view); });
    }
    var saved = 'grid';
    try { saved = localStorage.getItem('ls-collection-view') || 'grid'; } catch (e) {}
    apply(saved);
    btns.forEach(function (b) {
      b.addEventListener('click', function () {
        var view = b.getAttribute('data-view-btn');
        try { localStorage.setItem('ls-collection-view', view); } catch (e) {}
        apply(view);
      });
    });
  })();

  /* ---- Collection filters: toggle + auto-submit ---- */
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-filter-toggle]');
    if (!t) return;
    var layout = document.querySelector('[data-collection-layout]');
    if (!layout) return;
    // Defaults differ by viewport (shown on desktop, hidden on mobile), so flip based on what's actually visible.
    var filters = layout.querySelector('.collection-filters');
    var shown = filters && getComputedStyle(filters).display !== 'none';
    layout.classList.remove('is-filtering', 'is-hidden');
    layout.classList.add(shown ? 'is-hidden' : 'is-filtering');
    t.setAttribute('aria-expanded', shown ? 'false' : 'true');
  });
  document.addEventListener('change', function (e) {
    var el = e.target.closest('[data-auto-submit]');
    if (!el) return;
    var form = el.closest('[data-filter-form]');
    if (form) form.submit();
  });

  /* ---- Product card/row: preview colour image on swatch hover ---- */
  function swatchImg(sw) {
    var card = sw.closest('.product-card, .product-row');
    return card && card.querySelector('.product-card__img, .product-row__media img');
  }
  document.addEventListener('mouseover', function (e) {
    var sw = e.target.closest('[data-swatch-img]');
    if (!sw) return;
    var url = sw.getAttribute('data-swatch-img');
    if (!url) return;
    var img = swatchImg(sw);
    if (!img) return;
    if (img.dataset.origSrc === undefined) { img.dataset.origSrc = img.src; img.dataset.origSrcset = img.srcset || ''; }
    img.src = url; img.srcset = '';
  });
  document.addEventListener('mouseout', function (e) {
    var sw = e.target.closest('[data-swatch-img]');
    if (!sw) return;
    var img = swatchImg(sw);
    if (!img || img.dataset.origSrc === undefined) return;
    img.src = img.dataset.origSrc; img.srcset = img.dataset.origSrcset;
  });

  /* ---- Variant picker (colour swatches + size pills) ---- */
  function slugify(s) {
    return String(s || '').toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');
  }
  function setupVariantPicker(picker) {
    var jsonEl = picker.querySelector('[data-variant-json]');
    if (!jsonEl || picker.dataset.pickerReady) return;
    picker.dataset.pickerReady = '1';
    var variants;
    try { variants = JSON.parse(jsonEl.textContent); } catch (e) { return; }

    var area = picker.closest('[data-product-area]') || picker.closest('.product__info') || document;
    var form = picker.closest('form');
    var idInput = (form || area).querySelector('[data-variant-id]');
    var priceLabel = area.querySelector('[data-price-target]') || area.querySelector('[id^="price-"]');
    var submitBtn = form ? form.querySelector('[type="submit"]') : null;
    var colorLabel = picker.querySelector('[data-option-current]');
    var groups = Array.prototype.slice.call(picker.querySelectorAll('.variant-group'));
    var lastColor;

    function selectedValues() {
      return groups.map(function (g) {
        var sel = g.querySelector('.is-selected');
        return sel ? sel.getAttribute('data-option-value') : null;
      });
    }

    function findVariant(vals) {
      return variants.filter(function (v) {
        return v.options.length === vals.length && v.options.every(function (o, i) { return o === vals[i]; });
      })[0];
    }

    function markAvailability(vals) {
      groups.forEach(function (g, gi) {
        g.querySelectorAll('[data-option-value]').forEach(function (btn) {
          var test = vals.slice();
          test[gi] = btn.getAttribute('data-option-value');
          var ok = variants.some(function (v) {
            if (!v.available) return false;
            return v.options.every(function (o, i) { return i === gi ? o === test[gi] : (vals[i] == null || o === vals[i]); });
          });
          btn.classList.toggle('is-unavailable', !ok);
        });
      });
    }

    function update() {
      var vals = selectedValues();
      markAvailability(vals);
      var variant = findVariant(vals);
      if (variant) {
        if (idInput) idInput.value = variant.id;
        if (priceLabel) priceLabel.textContent = variant.price;
        if (variant.image) {
          var imgEl = area.querySelector('[data-variant-image]');
          if (imgEl) { imgEl.src = variant.image; imgEl.srcset = ''; }
        }
        if (submitBtn) {
          if (variant.available) {
            submitBtn.disabled = false; submitBtn.removeAttribute('aria-disabled');
            submitBtn.textContent = submitBtn.getAttribute('data-add-label') || submitBtn.textContent;
          } else {
            submitBtn.disabled = true; submitBtn.setAttribute('aria-disabled', 'true');
            submitBtn.textContent = submitBtn.getAttribute('data-soldout-label') || 'Sold out';
          }
        }
      }
      var swatch = picker.querySelector('.variant-swatch.is-selected');
      if (swatch) {
        if (colorLabel) colorLabel.textContent = swatch.getAttribute('data-option-value');
        var slug = slugify(swatch.getAttribute('data-option-value'));
        if (slug !== lastColor) {
          lastColor = slug;
          document.dispatchEvent(new CustomEvent('ls:colorchange', { detail: { color: slug } }));
        }
      }
    }

    picker.addEventListener('click', function (e) {
      var btn = e.target.closest('.variant-swatch, .variant-pill');
      if (!btn || !picker.contains(btn)) return;
      var group = btn.closest('.variant-group');
      group.querySelectorAll('.is-selected').forEach(function (b) { b.classList.remove('is-selected'); });
      btn.classList.add('is-selected');
      update();
    });

    update();
  }
  document.querySelectorAll('[data-variant-picker]').forEach(setupVariantPicker);

  /* ---- Quantity steppers ---- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-qty-up], [data-qty-down]');
    if (!btn) return;
    var input = btn.parentElement.querySelector('input[name="quantity"]');
    if (!input) return;
    var val = parseInt(input.value, 10) || 1;
    if (btn.hasAttribute('data-qty-up')) val += 1;
    else val = Math.max(1, val - 1);
    input.value = val;
  });

  /* ---- Safari: swap the alternate logo SVG for a PNG (Safari blurs filtered SVGs) ---- */
  var isSafari = /^((?!chrome|chromium|android|crios|fxios|edg).)*safari/i.test(navigator.userAgent);
  if (isSafari) {
    document.querySelectorAll('[data-logo-alt-png]').forEach(function (img) {
      img.src = img.getAttribute('data-logo-alt-png');
    });
    var fav = document.querySelector('link[data-favicon][data-png]');
    if (fav) { fav.type = 'image/png'; fav.href = fav.getAttribute('data-png'); }
  }

  /* ---- Marquee: fill each half to the viewport, then clone for a seamless loop ---- */
  function setupMarquee(marquee) {
    var track = marquee.querySelector('[data-marquee-track]');
    var group = marquee.querySelector('[data-marquee-group]');
    if (!track || !group) return;
    if (!group.dataset.base) group.dataset.base = group.innerHTML;
    while (track.children.length > 1) track.removeChild(track.lastChild);
    group.innerHTML = group.dataset.base;
    var guard = 0;
    while (group.scrollWidth < marquee.clientWidth && guard < 30) {
      group.innerHTML += group.dataset.base;
      guard++;
    }
    var clone = group.cloneNode(true);
    clone.removeAttribute('data-marquee-group');
    clone.setAttribute('aria-hidden', 'true');
    track.appendChild(clone);
  }
  var marquees = document.querySelectorAll('[data-marquee]');
  marquees.forEach(setupMarquee);
  if (marquees.length) {
    var marqTimer;
    window.addEventListener('resize', function () {
      clearTimeout(marqTimer);
      marqTimer = setTimeout(function () { marquees.forEach(setupMarquee); }, 200);
    });
  }

  /* ---- Quick-buy / notify drawer ---- */
  var quickDrawer = document.querySelector('[data-quick-drawer]');
  var quickBody = quickDrawer && quickDrawer.querySelector('[data-quick-body]');
  var quickHeading = quickDrawer && quickDrawer.querySelector('.quick-drawer__heading');
  function closeQuickDrawer() {
    if (!quickDrawer) return;
    quickDrawer.classList.remove('is-open');
    document.documentElement.style.overflow = '';
  }
  function openQuickDrawer(heading) {
    if (!quickDrawer) return;
    if (quickHeading && heading) quickHeading.textContent = heading;
    quickDrawer.classList.add('is-open');
    document.documentElement.style.overflow = 'hidden';
  }
  function loadDrawer(url, sectionId, heading, onLoad) {
    if (!quickDrawer || !quickBody) return;
    openQuickDrawer(heading);
    quickBody.innerHTML = '<div class="quick-drawer__loading u-mono">Loading…</div>';
    fetch(url.split('?')[0] + '?section_id=' + sectionId, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) { return r.text(); })
      .then(function (html) { quickBody.innerHTML = html; if (onLoad) onLoad(); })
      .catch(function () { quickBody.innerHTML = '<div class="quick-drawer__loading u-mono">Could not load. Please try again.</div>'; });
  }
  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('[data-quick-add]');
    if (trigger) {
      e.preventDefault(); e.stopPropagation();
      loadDrawer(trigger.getAttribute('data-quick-add'), 'quick-buy', 'Choose options', function () {
        var picker = quickBody.querySelector('[data-variant-picker]');
        if (picker) setupVariantPicker(picker);
      });
      return;
    }
    var notify = e.target.closest('[data-notify]');
    if (notify) {
      e.preventDefault(); e.stopPropagation();
      loadDrawer(notify.getAttribute('data-notify'), 'notify-me', 'Back in stock');
      return;
    }
    if (e.target.closest('[data-quick-close]')) closeQuickDrawer();
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeQuickDrawer(); });

  /* ---- Notify-me (back in stock) request ---- */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-notify-form]');
    if (!form) return;
    e.preventDefault();
    var btn = form.querySelector('[type="submit"]');
    if (btn) { btn.disabled = true; btn.textContent = 'Sending…'; }
    fetch(form.action, { method: 'POST', body: new FormData(form), headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function () {
        var ok = form.parentNode.querySelector('[data-notify-success]');
        if (ok) ok.hidden = false;
        form.hidden = true;
      })
      .catch(function () { if (btn) { btn.disabled = false; btn.textContent = 'Notify me'; } });
  });

  /* ---- Buy it now (quick-buy + anywhere) ---- */
  document.addEventListener('click', function (e) {
    var bn = e.target.closest('[data-buy-now]');
    if (!bn) return;
    var form = bn.closest('form');
    if (!form) return;
    var idEl = form.querySelector('[name="id"]');
    var qtyEl = form.querySelector('[name="quantity"]');
    if (!idEl) return;
    bn.disabled = true;
    fetch(window.routes.cart_add_url, {
      method: 'POST',
      headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: new URLSearchParams({ id: idEl.value, quantity: (qtyEl && qtyEl.value) || 1 })
    }).then(function () { window.location.href = '/checkout'; })
      .catch(function () { bn.disabled = false; });
  });

  /* ---- Product description show/hide ---- */
  var DESC_CLAMP = 140;
  document.querySelectorAll('[data-desc-wrap]').forEach(function (wrap) {
    var content = wrap.querySelector('[data-desc]');
    var btn = wrap.querySelector('[data-desc-toggle]');
    if (!content || !btn) return;
    if (content.scrollHeight > DESC_CLAMP + 8) {
      wrap.classList.add('is-clamped');
      btn.hidden = false;
    }
  });
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-desc-toggle]');
    if (!btn) return;
    var wrap = btn.closest('[data-desc-wrap]');
    if (!wrap) return;
    var clamped = wrap.classList.toggle('is-clamped');
    btn.setAttribute('aria-expanded', clamped ? 'false' : 'true');
    btn.textContent = clamped ? 'Show more' : 'Show less';
  });
})();
